import { ArticleSearchParamsWithId } from '@obeta/models/lib/models/Search'
import { getFacetByWarehouseId } from '../getFacetByWarehouseId'
import { buildFilterParams } from './buildSearchFilter'

export const FACET_ETIM_DATA_CLASS_ID = 'zEtimData.class.id'
export const FACET_ETIM_DATA_FEATURES = 'zEtimData.features'
export const FACET_SUPPLIER_NAME = 'supplierFilterName'
export const FACET_LIST_PRICE = 'listPrice'
export const FACET_TYPE = 'type'

export const createMainRequest = (
  searchParams: ArticleSearchParamsWithId,
  itemsPerPage: number,
  page: number,
  warehouseId: string,
  searchFacets: string[]
) => ({
  searchString: searchParams.searchString,
  requestOptions: {
    hitsPerPage: itemsPerPage,
    filters: buildFilterParams(searchParams, warehouseId),
    page,
    facets: searchFacets,
    ruleContexts: searchParams.trigger && page === 0 ? searchParams.trigger : 'nosearchbar',
  },
})

export const createAvailabilityRequest = (
  searchParams: ArticleSearchParamsWithId,
  warehouseId: string
) => ({
  searchString: searchParams.searchString,
  requestOptions: {
    facets: [getFacetByWarehouseId(warehouseId)],
    filters:
      buildFilterParams({ ...searchParams, articleSearchArea: undefined }, warehouseId) || '',
  },
})

export const createSuppliersRequest = (
  searchParams: ArticleSearchParamsWithId,
  warehouseId: string
) => ({
  searchString: searchParams.searchString,
  requestOptions: {
    facets: [FACET_SUPPLIER_NAME],
    filters: buildFilterParams({ ...searchParams, suppliers: undefined }, warehouseId),
  },
})

export const createFilterRequest = (
  searchParams: ArticleSearchParamsWithId,
  warehouseId: string,
  searchFilterRequestFacets: string[]
) => ({
  searchString: searchParams.searchString,
  requestOptions: {
    facets: searchFilterRequestFacets,
    filters: buildFilterParams(searchParams, warehouseId),
  },
})
